import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export function PrivacyPolicyDE() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-100 to-indigo-100">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <button
          onClick={() => navigate('/')}
          className="inline-flex items-center text-indigo-600 hover:text-indigo-700 mb-6 transition-colors duration-200"
        >
          <ArrowLeft className="mr-2 h-5 w-5" />
          Zurück zur App
        </button>

        <article className="bg-white rounded-lg shadow-xl p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Datenschutzerklärung</h1>

          <div className="space-y-6 text-gray-700">
            <p className="text-sm text-gray-500">
              Zuletzt aktualisiert: {new Date().toLocaleDateString('de-DE')}
            </p>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Verantwortlicher für die Datenverarbeitung</h2>
              <div className="space-y-3 bg-gray-50 p-4 rounded-lg">
                <p className="leading-relaxed">
                  <strong>Der Verantwortliche ist:</strong>
                </p>
                <div className="ml-4 space-y-1">
                  <p><strong>Name:</strong> Puretech s.r.o.</p>
                  <p><strong>Registrierungsnummer:</strong> 05503795</p>
                  <p><strong>Standort:</strong> Tschechische Republik</p>
                  <p><strong>Kontakt:</strong> support@simplestickers.app</p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Welche Informationen wir sammeln</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  <strong>Kontoinformationen:</strong> Wenn Sie ein Konto erstellen, erfassen wir Ihre E-Mail-Adresse und alle Profilinformationen, die Sie bereitstellen möchten.
                </p>
                <p className="leading-relaxed">
                  <strong>Nutzungsdaten:</strong> Wir erfassen Informationen darüber, wie Sie unseren Service nutzen, einschließlich erstellter Aufgaben, verwalteter Projekte und Nutzungsmuster von Funktionen.
                </p>
                <p className="leading-relaxed">
                  <strong>Zahlungsinformationen:</strong> Die Zahlungsabwicklung erfolgt durch Polar. Wir speichern Ihre Zahlungskarteninformationen nicht auf unseren Servern.
                </p>
                <p className="leading-relaxed">
                  <strong>Technische Daten:</strong> Wir erfassen automatisch bestimmte technische Informationen, einschließlich IP-Adresse, Browsertyp, Betriebssystem und Geräteinformationen.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Wie wir Ihre Informationen verwenden</h2>
              <div className="space-y-2">
                <p className="leading-relaxed">Wir verwenden die gesammelten Informationen, um:</p>
                <ul className="list-disc ml-6 space-y-1">
                  <li>Unsere Dienste bereitzustellen, zu pflegen und zu verbessern</li>
                  <li>Transaktionen zu verarbeiten und Abonnements zu verwalten</li>
                  <li>Ihnen technische Hinweise und Support-Nachrichten zu senden</li>
                  <li>Auf Ihre Kommentare und Fragen zu antworten</li>
                  <li>Nutzungsmuster zu analysieren, um die Benutzererfahrung zu verbessern</li>
                  <li>Unsere Geschäftsbedingungen durchzusetzen</li>
                  <li>Gesetzliche Verpflichtungen zu erfüllen</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Weitergabe von Informationen</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Wir verkaufen, handeln oder übertragen Ihre persönlichen Daten nicht an Dritte, außer wie in dieser Richtlinie beschrieben:
                </p>
                <ul className="list-disc ml-6 space-y-1">
                  <li><strong>Dienstleister:</strong> Wir können Informationen mit vertrauenswürdigen Dritten teilen, die uns beim Betrieb unseres Dienstes unterstützen (z.B. Polar für Zahlungsabwicklung, Supabase für Datenbankdienste)</li>
                  <li><strong>Gesetzliche Anforderungen:</strong> Wir können Informationen offenlegen, wenn dies gesetzlich vorgeschrieben ist oder um unsere Rechte zu schützen</li>
                  <li><strong>Unternehmensübertragungen:</strong> Im Falle einer Fusion, Übernahme oder Vermögensveräußerung können Benutzerinformationen übertragen werden</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Datensicherheit</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Wir implementieren angemessene technische und organisatorische Sicherheitsmaßnahmen, um Ihre persönlichen Daten vor unbefugtem Zugriff, Änderung, Offenlegung oder Zerstörung zu schützen. Allerdings ist keine Übertragungsmethode über das Internet zu 100% sicher.
                </p>
                <p className="leading-relaxed">
                  <strong>Reaktion auf Sicherheitsverletzungen:</strong> Im Falle einer Verletzung personenbezogener Daten werden wir gemäß DSGVO vorgehen:
                </p>
                <ul className="list-disc ml-6 space-y-1">
                  <li>Meldung des Vorfalls an die Aufsichtsbehörde innerhalb von 72 Stunden nach Entdeckung</li>
                  <li>Benachrichtigung betroffener Benutzer, wenn die Verletzung ein hohes Risiko für ihre Rechte und Freiheiten darstellt</li>
                  <li>Ergreifen von Maßnahmen zur Minimierung der Auswirkungen und Verhinderung zukünftiger Vorfälle</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Datenspeicherung</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Wir speichern Ihre persönlichen Daten so lange, wie es zur Bereitstellung unserer Dienste erforderlich ist. Spezifische Aufbewahrungsfristen sind:
                </p>
                <ul className="list-disc ml-6 space-y-1">
                  <li><strong>Kontodaten:</strong> Dauer der Dienstleistung + 30 Tage nach Kontolöschung</li>
                  <li><strong>Aufgabeninhalte (Sticky Notes):</strong> Bis Sie sie löschen oder das Konto kündigen</li>
                  <li><strong>Zahlungsunterlagen:</strong> 7 Jahre (Anforderung des tschechischen Rechnungslegungsgesetzes)</li>
                  <li><strong>Analysedaten:</strong> Bis zu 26 Monate</li>
                  <li><strong>Backup-Daten:</strong> Können bis zu 90 Tage nach der primären Löschung bestehen bleiben</li>
                  <li><strong>Anonymisierte Daten:</strong> Unbegrenzt für statistische Zwecke aufbewahrt</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Ihre Rechte gemäß DSGVO</h2>
              <div className="space-y-2">
                <p className="leading-relaxed">Sie haben das Recht auf:</p>
                <ul className="list-disc ml-6 space-y-1">
                  <li>Zugang zu den personenbezogenen Daten, die wir über Sie speichern</li>
                  <li>Berichtigung unrichtiger personenbezogener Daten</li>
                  <li>Löschung Ihrer personenbezogenen Daten</li>
                  <li>Widerspruch gegen oder Einschränkung der Verarbeitung Ihrer Daten</li>
                  <li>Datenübertragbarkeit (Erhalt einer Kopie Ihrer Daten in einem strukturierten Format)</li>
                  <li>Widerruf der Einwilligung jederzeit</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Cookies und Tracking</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Wir verwenden Cookies und ähnliche Tracking-Technologien, um Ihre Erfahrung zu verbessern. Arten von Cookies, die wir verwenden:
                </p>
                <ul className="list-disc ml-6 space-y-1">
                  <li><strong>Erforderliche Cookies:</strong> Notwendig für die Funktionalität des Dienstes (Authentifizierung, Anmeldung)</li>
                  <li><strong>Analyse-Cookies:</strong> Helfen uns zu verstehen, wie Sie unseren Dienst nutzen (Sie können ablehnen)</li>
                  <li><strong>Drittanbieter-Cookies:</strong> Google OAuth, Polar für Zahlungen</li>
                </ul>
                <p className="leading-relaxed">
                  Sie können Cookie-Einstellungen über Ihre Browser-Einstellungen oder unser Cookie-Banner beim ersten Besuch steuern.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Drittanbieterdienste</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">Unser Dienst ist mit Drittanbieterdiensten integriert:</p>
                <ul className="list-disc ml-6 space-y-1">
                  <li><strong>Google OAuth:</strong> Für Authentifizierung (unterliegt der Datenschutzrichtlinie von Google)</li>
                  <li><strong>Polar:</strong> Für Zahlungsabwicklung (unterliegt der Datenschutzrichtlinie von Polar)</li>
                  <li><strong>Supabase:</strong> Für Datenbank- und Authentifizierungsdienste</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">10. Datenschutz für Kinder</h2>
              <p className="leading-relaxed">
                Unser Dienst richtet sich nicht an Kinder unter 16 Jahren. Wir erfassen wissentlich keine persönlichen Daten von Kindern unter 16 Jahren. Wenn Sie ein Elternteil oder Vormund sind und glauben, dass Ihr Kind uns persönliche Daten zur Verfügung gestellt hat, kontaktieren Sie uns bitte unter support@simplestickers.app.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">11. Internationale Datenübertragungen</h2>
              <p className="leading-relaxed">
                Ihre Daten können in Länder außerhalb Ihres Wohnsitzlandes übertragen und dort verarbeitet werden. Wir stellen sicher, dass angemessene Schutzmaßnahmen zum Schutz Ihrer personenbezogenen Daten gemäß den geltenden Datenschutzgesetzen vorhanden sind.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">12. Änderungen dieser Richtlinie</h2>
              <p className="leading-relaxed">
                Wir können diese Datenschutzrichtlinie von Zeit zu Zeit aktualisieren. Wir werden Sie über wesentliche Änderungen informieren, indem wir die neue Richtlinie auf dieser Seite veröffentlichen und das Datum "Zuletzt aktualisiert" aktualisieren.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">13. Automatisierte Entscheidungsfindung</h2>
              <p className="leading-relaxed">
                Unser Dienst verwendet KI-Algorithmen zur Generierung von Aufgabenvorschlägen. Diese Funktion ist rein unterstützend und trifft keine Entscheidungen mit rechtlichen oder erheblichen Auswirkungen auf Benutzer. Sie können jederzeit entscheiden, keine Vorschläge zu verwenden.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">14. Aufsichtsbehörde</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Sie haben das Recht, eine Beschwerde bei der Aufsichtsbehörde für Datenschutz einzureichen:
                </p>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <p><strong>Tschechisches Amt für den Schutz personenbezogener Daten (ÚOOÚ)</strong></p>
                  <p className="text-sm mt-2">Pplk. Sochora 27, 170 00 Prag 7</p>
                  <p className="text-sm">Web: <a href="https://www.uoou.cz" className="text-indigo-600 hover:underline">www.uoou.cz</a></p>
                  <p className="text-sm">E-Mail: posta@uoou.cz</p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">15. Wie Sie Ihre Rechte ausüben können</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Um Ihre Rechte gemäß DSGVO auszuüben (Datenzugang, Berichtigung, Löschung, Übertragbarkeit, Widerspruch usw.):
                </p>
                <ul className="list-disc ml-6 space-y-1">
                  <li>Senden Sie uns eine Anfrage an <strong>support@simplestickers.app</strong></li>
                  <li>Wir werden innerhalb von <strong>1 Monat</strong> nach Erhalt Ihrer Anfrage antworten</li>
                  <li>Wir können Sie bitten, Ihre Identität zu bestätigen</li>
                  <li>Der Service ist <strong>kostenlos</strong> (es sei denn, die Anfrage ist offensichtlich unbegründet oder übermäßig)</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">16. Kontaktieren Sie uns</h2>
              <p className="leading-relaxed">
                Wenn Sie Fragen zu dieser Datenschutzrichtlinie oder unseren Datenpraktiken haben, kontaktieren Sie uns bitte:
              </p>
              <div className="mt-4 bg-gray-50 p-4 rounded-lg">
                <p className="text-sm text-gray-700">
                  <strong>E-Mail:</strong> support@simplestickers.app
                </p>
                <p className="text-xs text-gray-500 mt-2">
                  Für alle Fragen zu Datenschutz, Datenanfragen, Support und anderen Anfragen
                </p>
              </div>
            </section>
          </div>
        </article>
      </div>
    </div>
  );
}
